import React, { useEffect, useMemo, useState } from 'react';

import { Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { DateTime } from 'luxon';

import { getProfessionalInvoice, professionalInvoice } from '@pharmaplan/common';

import ResponsiveClasses from '../../../theme/ResponsiveClasses';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import AdsContainer from '../../common/AdsContainer';

import Invoice from '../Invoice';

export interface IInvoiceStateBookings {
  startDate: DateTime;
  endDate: DateTime;
  paidHourlyRate: number;
  bookingId: string;
  changed?: boolean;
}

const InvoiceLayout = () => {
  const dispatch = useAppDispatch();

  const { state } = useLocation();
  const { bookingIds, isAutoSyncRecord } = state ?? {};

  const invoice = useAppSelector(professionalInvoice);
  const { bookings } = invoice ?? {};

  const transformedBookings = useMemo(
    () =>
      bookings.reduce((acc: Record<string, IInvoiceStateBookings>, curr) => {
        acc[curr.bookingId] = {
          ...curr,
          startDate: DateTime.fromISO(curr.startDate, { setZone: true }),
          endDate: DateTime.fromISO(curr.endDate, { setZone: true }),
        };
        return acc;
      }, {}),
    [bookings],
  );

  const [invoiceState, setInvoiceState] = useState(transformedBookings);

  useEffect(() => {
    dispatch(getProfessionalInvoice({ bookingIds, isAutoSyncRecord }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setInvoiceState(transformedBookings);
  }, [transformedBookings]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={10}>
        <Invoice
          setInvoiceState={setInvoiceState}
          invoiceState={invoiceState}
        />
      </Grid>
      <Grid sx={ResponsiveClasses.hideOnLg} item xs={2}>
        <AdsContainer />
      </Grid>
    </Grid>
  );
};

export default InvoiceLayout;
